import React, { useEffect, useState } from 'react'
import Breadcrumb from '../../../core/common/Breadcrumb/breadcrumb'
import ProfileCard from '../common/profileCard'
import StudentSidebar from '../common/studentSidebar'
import CircleProgress from '../../Instructor/instructor-dashboard/circleProgress'
import { Link } from 'react-router-dom'
import ImageWithBasePath from '../../../core/common/imageWithBasePath'
import { all_routes } from '../../router/all_routes'
import apiInstance from '../../../utility/apiInstance'
import { useSelector } from 'react-redux'
import { Application } from '../../../core/types/types'
import { getCurrencySymbol } from '../../../utility/currencyUtils'

const StudentDashboard = () => {
    const [selectedItems, setSelectedItems] = useState(Array(4).fill(false));
    const handleItemClick = (index: number) => {
        setSelectedItems((prevSelectedItems) => {
            const updatedSelectedItems = [...prevSelectedItems];
            updatedSelectedItems[index] = !updatedSelectedItems[index];
            return updatedSelectedItems;
        });
    };

    const user = useSelector((state: any) => state.auth.user);
    const [applications, setApplications] = useState<[Application]>();
    const [activeApplications, setActiveApplications] = useState<[Application]>();
    const [approvedApplications, setApprovedApplications] = useState<[Application]>();
    const [refreshKey, setRefreshKey] = useState(0);
    const [paymentStatus, setPaymentStatus] = useState<'success' | 'cancelled' | null>(null);
    useEffect(() => {
        const fetchApplications = async () => {
            try {
                const response = await apiInstance.get("/api/applications", {
                    params: {
                        "where[student][equals]": user.id,
                    },
                });

                const applications = response.data.docs;
                setApplications(applications);
                setActiveApplications(applications.filter((item: Application) => item?.status === 'in_review'))
                setApprovedApplications(applications.filter((item: Application) => item?.status === 'approved'))
            } catch (error) {
                console.error("Error fetching applications:", error);
            }
        };

        fetchApplications();
    }, [user?.id, refreshKey]);

    const [isPaying, setIsPaying] = useState<string | null>(null);

    // Stripe sends the user back with ?payment=success|cancelled. The webhook that marks
    // the fee as paid can land a moment after the redirect, so refetch once shortly after.
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const status = params.get('payment');
        if (status !== 'success' && status !== 'cancelled') return;
        setPaymentStatus(status);
        window.history.replaceState(null, '', window.location.pathname);
        if (status === 'success') {
            const timer = setTimeout(() => setRefreshKey((k) => k + 1), 3000);
            return () => clearTimeout(timer);
        }
    }, []);

    const handlePayment = async (app: Application) => {
        try {
            setIsPaying(app.id);
            // The server looks up the fee and currency from the application itself.
            const response = await apiInstance.post("/api/create-checkout-session", {
                applicationId: app.id,
                returnUrl: `${window.location.origin}${all_routes.studentDashboard}`,
            });

            if (response.data.success && response.data.checkoutUrl) {
                window.location.href = response.data.checkoutUrl;
                return;
            }
            alert(response.data.error || "Failed to start payment process. Please try again.");
        } catch (error: any) {
            console.error("Error initiating payment:", error);
            alert(error?.response?.data?.error || "An error occurred. Please try again.");
        }
        setIsPaying(null);
    };

    return (
        <>
            <div className="content">
                <div className="container">
                    {/* profile box */}
                    <ProfileCard />
                    {/* profile box */}
                    <div className="row">
                        {/* sidebar */}
                        <StudentSidebar />
                        {/* sidebar */}
                        <div className="col-lg-9">
                            {paymentStatus && (
                                <div className={`alert ${paymentStatus === 'success' ? 'alert-success' : 'alert-warning'} alert-dismissible`} role="alert">
                                    {paymentStatus === 'success'
                                        ? 'Payment received. Your application will show as Paid shortly.'
                                        : 'Payment was cancelled. You can try again any time.'}
                                    <button type="button" className="btn-close" onClick={() => setPaymentStatus(null)}></button>
                                </div>
                            )}
                            {/* <h5 className="mb-3 fs-18"></h5>
                            <div className="mb-5">
                                <ImageWithBasePath
                                    src="./assets/img/progress.svg"
                                    className="quiz-ans-bg1"
                                    alt="img"
                                />
                            </div> */}
                            <div className="row">
                                <div className="col-md-6 col-xl-4">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="d-flex align-items-center">
                                                <span className="icon-box bg-primary-transparent me-2 me-xxl-3 flex-shrink-0">
                                                    <ImageWithBasePath src="assets/img/icon/graduation.svg" alt="" />
                                                </span>
                                                <div>
                                                    <span className="d-block">Enrolled Programs</span>
                                                    <h4 className="fs-24 mt-1">{applications?.length || 0}</h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 col-xl-4">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="d-flex align-items-center">
                                                <span className="icon-box bg-secondary-transparent me-2 me-xxl-3 flex-shrink-0">
                                                    <ImageWithBasePath src="assets/img/icon/book.svg" alt="" />
                                                </span>
                                                <div>
                                                    <span className="d-block">Under Review</span>
                                                    <h4 className="fs-24 mt-1">{activeApplications?.length}</h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 col-xl-4">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="d-flex align-items-center">
                                                <span className="icon-box bg-success-transparent me-2 me-xxl-3 flex-shrink-0">
                                                    <ImageWithBasePath src="assets/img/icon/bookmark.svg" alt="" />
                                                </span>
                                                <div>
                                                    <span className="d-block">Approved Programs</span>
                                                    <h4 className="fs-24 mt-1">{approvedApplications?.length}</h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card bg-light quiz-ans-card">
                                <div className="card-body">
                                    <div className="row align-items-center">
                                        <div className="col-md-8">
                                            <div>
                                                <h6 className="mb-1">Complete your profile </h6>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="text-end">
                                                <Link
                                                    to={all_routes.studentSettings}
                                                    className="btn btn-primary rounded-pill"
                                                >
                                                    Profile
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card bg-light quiz-ans-card">
                                <div className="card-body">
                                    <div className="row align-items-center">
                                        <div className="col-md-8">
                                            <div>
                                                <h6 className="mb-1">Start Applying </h6>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="text-end">
                                                <Link
                                                    to={all_routes.allProgramsGrid}
                                                    className="btn btn-primary rounded-pill"
                                                >
                                                    Find a Program
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <h5 className="mb-3 fs-18">Recent Applications</h5>
                            <div>
                                <div className="row">
                                    <div className="col-xl-12">
                                        <div className="card">
                                            <div className="card-body">
                                                {applications && applications?.length > 0 && applications.slice(0, 5)?.map((item) => (
                                                    <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 mb-3">
                                                        <div>
                                                            <h6 className="mb-1" style={{
                                                                maxWidth: "800px",
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis",
                                                                whiteSpace: "nowrap",
                                                            }} title={item?.program?.programName}>
                                                                {item?.program?.programName}
                                                            </h6>
                                                            <div className="d-flex align-items-center">
                                                                <span className="badge badge-sm bg-light border d-inline-flex me-3">
                                                                    <span
                                                                        className={
                                                                            item?.status === "pending"
                                                                                ? "text-warning fw-bold"
                                                                                : item?.status === "in_review"
                                                                                    ? "text-info fw-bold"
                                                                                    : item?.status === "approved"
                                                                                        ? "text-success fw-bold"
                                                                                        : item?.status === "declined"
                                                                                            ? "text-danger fw-bold"
                                                                                            : ""
                                                                        }
                                                                    >
                                                                        {item?.status || "pending"}
                                                                    </span>
                                                                </span>
                                                                <p className="small">
                                                                    Application Fee :{" "}
                                                                    <span className="heading-color fw-semibold">
                                                                        {item?.applicationFee ? `${getCurrencySymbol(item?.institution?.country)}${item.applicationFee}` : 'Free'}
                                                                    </span>
                                                                    {item?.applicationFee > 0 && (
                                                                        <span className={`ms-2 fs-10 badge ${item.isApplicationFeePaid ? 'bg-success' : 'bg-danger'}`}>
                                                                            {item.isApplicationFeePaid ? 'Paid' : 'Unpaid'}
                                                                        </span>
                                                                    )}
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="d-flex align-items-center gap-3">
                                                            {item?.applicationFee > 0 && !item.isApplicationFeePaid && (
                                                                <button
                                                                    className="btn btn-sm btn-primary py-1 px-3 fs-12"
                                                                    onClick={() => handlePayment(item)}
                                                                    disabled={isPaying === item.id}
                                                                >
                                                                    {isPaying === item.id ? 'Processing...' : 'Pay Now'}
                                                                </button>
                                                            )}
                                                            <span className="text-muted small">
                                                                {item?.createdAt ? new Date(item.createdAt).toLocaleDateString() : ''}
                                                            </span>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="col-xl-5">
                                        <div className="card mb-0">
                                            <div className="card-body">
                                                <h5 className="mb-3 fs-18 border-bottom pb-3">
                                                    Latest Quizes
                                                </h5>
                                                <div className="d-flex align-items-center flex-wrap flex-md-nowrap justify-content-between row-gap-2 mb-3">
                                                    <div>
                                                        <h6 className="mb-1">Sketch from A to Z (2024)</h6>
                                                        <div className="d-flex align-items-center">
                                                            <p>Correct Answer : 15/22</p>
                                                        </div>
                                                    </div>

                                                    <CircleProgress value={95} />
                                                </div>
                                                <div className="d-flex align-items-center flex-wrap flex-md-nowrap justify-content-between row-gap-2 mb-3">
                                                    <div>
                                                        <h6 className="mb-1">Build Responsive Real World </h6>
                                                        <div className="d-flex align-items-center">
                                                            <p>Correct Answer : 18/22</p>
                                                        </div>
                                                    </div>
                                                    <CircleProgress value={100} />
                                                </div>
                                                <div className="d-flex align-items-center flex-wrap flex-md-nowrap justify-content-between row-gap-2 mb-3">
                                                    <div>
                                                        <h6 className="mb-1">UI/UX Design Degree</h6>
                                                        <div className="d-flex align-items-center">
                                                            <p>Correct Answer : 25/30</p>
                                                        </div>
                                                    </div>
                                                    <CircleProgress value={80} />
                                                </div>
                                                <div className="d-flex align-items-center flex-wrap flex-md-nowrap justify-content-between row-gap-2 mb-3">
                                                    <div>
                                                        <h6 className="mb-1">Build Responsive Real World </h6>
                                                        <div className="d-flex align-items-center">
                                                            <p>Correct Answer : 15/20</p>
                                                        </div>
                                                    </div>
                                                    <CircleProgress value={85} />
                                                </div>
                                                <div className="d-flex align-items-center flex-wrap flex-md-nowrap justify-content-between row-gap-2">
                                                    <div>
                                                        <h6 className="mb-1">Become an app designer</h6>
                                                        <div className="d-flex align-items-center">
                                                            <p>Correct Answer : 12/20</p>
                                                        </div>
                                                    </div>
                                                    <CircleProgress value={20} />
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default StudentDashboard